import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActiveItemDirective } from './active-item.directive';
import { ActiveRouteDirective } from './active-route.directive';
import { TooltipDirective } from './tooltip.directive';
import { StateColorDirective } from './state-color.directive';

@NgModule({
  declarations: [
    ActiveItemDirective,
    ActiveRouteDirective,
    TooltipDirective,
    StateColorDirective,
  ],
  imports: [CommonModule],
  exports: [
    ActiveItemDirective,
    ActiveRouteDirective,
    TooltipDirective,
    StateColorDirective,
  ]
})
export class DirectiveModule {}
